import HubTab from './HubTab';
export default HubTab;
